import { Controller } from '@hotwired/stimulus'

export default class LocationSourceController extends Controller {
  navigate (event) {
    const url = event.target.value
    const current = [...this.element.options].find(option => option.defaultSelected)
    if (current) this.element.value = current.value
    window.location.assign(url)
  }
}
